import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateUser } from '../store/slices/authSlice';

const VerificationChecker = ({ children }) => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    // Only check verification status if user is authenticated
    if (isAuthenticated && user) {
      // Update user data to refresh verification status
      // This will trigger the isUserVerified function in the slice
      dispatch(updateUser(user));
    }
  }, [isAuthenticated, user, dispatch]);

  return children;
};

export default VerificationChecker;
